import React from 'react';
import { useSanitizedTranslation } from '../hooks';

export type DisclaimerProps = {
  disclaimer: string;
  top?: number;
  align?: 'center' | 'left' | 'right';
  offset?: number;
  background?: string;
  text?: string;
};

const Disclaimer: React.FC<DisclaimerProps> = ({ disclaimer, top = 0, align = 'center', offset = 0, background = '#FFFFFF', text = '#000000' }) => {
  const { t } = useSanitizedTranslation();

  return (
    <div className={`relative z-20 w-full py-16`} style={{ top, zIndex: 5, textAlign: align, backgroundColor: background }}>
      <div className="wrapper type-body relative text-[14px]">
        <div
          style={{ paddingLeft: align === 'left' ? offset : 0, paddingRight: align === 'right' ? offset : 0, color: text }}
          data-i18n={t(disclaimer)}
          className={`text-[${text}]`}
          dangerouslySetInnerHTML={{ __html: disclaimer }}
        />
      </div>
    </div>
  );
};

export default Disclaimer;
